export const MENU_EXTENDED = '258px';

export const MENU_NOT_EXTENDED = '72px';
